import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { FailedAnim, MplButton } from '@mopla/ui';

import { Root } from './AccountDeleted.styles';

export const AccountDeleted = () => {
	const { t } = useTranslation('personalDetails');

	const handleClose = () => {
		// Note: Force full page reload to ensure complete session cleanup
		window.location.replace('/welcome');
	};

	return (
		<Root>
			<Typography variant="title" color="neutral.0">
				{t('header.account_removed')}
			</Typography>
			<FailedAnim />
			<Typography variant="body1" color="neutral.0">
				{t('text.account_removed_description')}
			</Typography>
			<Box sx={{ mt: 1.5 }}>
				<MplButton fullWidth color="primaryRevert" onClick={handleClose}>
					{t('button.close')}
				</MplButton>
			</Box>
		</Root>
	);
};
